import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgErrorFilled = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 100,
	height: 100,
	viewBox: "0 0 41.967 48",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		id: "error-filled",
		d: "M44.393,4.374A5.179,5.179,0,0,0,40.721,2.8H8.984A5.179,5.179,0,0,0,5.311,4.374,7.068,7.068,0,0,0,4,8.308V40.046a4.229,4.229,0,0,0,1.574,3.41A5.179,5.179,0,0,0,9.246,45.03h10.23l5.508,5.77,5.508-5.77H40.984a4.229,4.229,0,0,0,3.41-1.574,5.179,5.179,0,0,0,1.574-3.672V8.046a4.762,4.762,0,0,0-1.574-3.672Zm-17.311,9.18L26.3,29.292H23.672l-.787-15.738ZM26.3,32.7v3.148H23.672V32.7Z",
		transform: "translate(-4 -2.8)",
		fill: "#ca1922",
		fillRule: "evenodd"
	})]
});
const ForwardRef = forwardRef(SvgErrorFilled);
export default ForwardRef;
